
module.exports = DEF.TG.Details.extend({
	template: require("./settings.html"),
});
